module.exports = __webpack_public_path__ + "static/media/phone-2.5ad0d3fe.svg";